import React from 'react';

import type { IModeToggleSwitchProps } from './ModeToggleSwitch.types';
import { ChatMode } from './ModeToggleSwitch.types';
import { SegmentedToggle } from '../SegmentedToggle/SegmentedToggle';
import { IconName } from '../Icon/Icon.type';

/**
 * The chat mode switcher.
 *
 * Only the modes live here — the pill rendering is SegmentedToggle's, so this
 * and every other toggle in the app move together when the tokens change.
 */
export const ModeToggleSwitch: React.FC<IModeToggleSwitchProps> = ({
  activeMode,
  onModeChange,
  className = '',
  disabled = false,
  showTickets = false,
}) => {
  const modes: { value: ChatMode; label: string; icon: IconName }[] = [
    { value: ChatMode.CAB, label: 'CAB', icon: IconName.Document },
    ...(showTickets ? [{ value: ChatMode.TICKETS, label: 'Tickets', icon: IconName.Tickets }] : []),
    { value: ChatMode.DESIGN, label: 'Prototype', icon: IconName.Design },
    { value: ChatMode.BUILD, label: 'Build', icon: IconName.Code },
  ];

  return (
    <SegmentedToggle<ChatMode>
      options={modes}
      value={activeMode}
      onChange={onModeChange}
      className={className}
      disabled={disabled}
      ariaLabel="Mode toggle"
    />
  );
};
